module.exports = __webpack_public_path__ + "static/img/shi2_2.fec6f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi2_2.png
// module id = iYTG
// module chunks = 1